import * as b from 'fp-ts/boolean';
import * as RR from 'fp-ts/ReadonlyRecord';
import * as s from 'fp-ts/string';
import * as t from 'io-ts';
export function fromEnum(theEnum, name) {
    var isEnumValue = function (input) { return RR.foldMap(s.Ord)(b.MonoidAny)(function (value) { return value === input; })(theEnum); };
    return new t.Type(name !== null && name !== void 0 ? name : 'Enum', isEnumValue, function (input, context) { return (isEnumValue(input) ? t.success(input) : t.failure(input, context)); }, t.identity);
}
